export default __webpack_public_path__ + "static/media/BlueError.a69773f1.svg";